import angular from 'angular';
import { routes } from "./normas.routes";
import DirectoryNormasController from "./directory/directory.controller";
export default angular.module('app.elv.normas', [])
    .config(routes)
    .controller('DirectoryNormasController', DirectoryNormasController)
    .name;
